/**
 * Template: Login
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Login template.
 *
 * @namespace login
 */
import BrontoDirectAdd from '~/components/bronto-direct-add';
document.addEventListener('DOMContentLoaded', () => {
  if (Shopify.shop !== 'meermin-seconds.myshopify.com') {
    BrontoDirectAdd().init();
  }
});